<ng-container>
    <i *ngIf="!item.IsArchived" title="archive" (click)="archive($event)" class="fa fa-2x fa-fw fa-trash icon-main"></i>
    <i *ngIf="item.IsArchived" title="un-archive" (click)="archive($event)" class="fa fa-2x fa-fw fa-unlock icon-main"></i>
</ng-container>
